import { ref } from 'vue';
import axios from 'axios';

function isAlreadyReserved(time, data) {
    const isFree = data.find((pair) => {
        const endTime = pair[0].split(' ')[1];

        return time === endTime;
    }).length;

    return !isFree;
}

export const useOnSubmit = (productId, checkoutlink) => {
    const isSubmitting = ref(false);
    const addedToCart = ref(false);
    const addedToCartMessage = ref(null);
    const externalErrors = ref([]);
    const onSubmit = (data, variation) => {
        if (isSubmitting.value) {
            isSubmitting.value = false;
            return;
        }

        isSubmitting.value = true;

        const formData = new FormData();

        formData.append('action', 'add_to_cart');
        formData.append('product_id', productId);
        formData.append('quantity', 1);
        formData.append('metaData', JSON.stringify(data));

        if (variation) {
            formData.append('variation', variation);
        }

        data.uploadedFile.forEach((file) => {
            formData.append('file[]', file);
        });

        function processAddingToCart() {
            fetch(jsData.ajaxUrl, {
                method: 'POST',
                body: formData,
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.success) {
                        window.location.href = checkoutlink;
                    } else {
                        if (response.data?.key) {
                            externalErrors.value = [
                                {
                                    key: response.data?.key,
                                    hint: response.data?.message,
                                },
                            ];
                        }
                        isSubmitting.value = false;
                        addedToCart.value = true;
                        addedToCartMessage.value = response.data.message;
                    }
                });
        }

        if (data.selectedConsultationDate) {
            const fetchDoctorFormData = new FormData();
            fetchDoctorFormData.append('action', 'wizyta_terminy');
            fetchDoctorFormData.append('prod', productId);
            fetchDoctorFormData.append('data', data.selectedConsultationDate.date);
            if (data.selectedDoctor?.id) {
                fetchDoctorFormData.append('lekarz', data.selectedDoctor.id);
            }

            axios.post(jsData.ajaxUrl, fetchDoctorFormData).then((resp) => {
                if (isAlreadyReserved(data.selectedConsultationDate.hour, resp.data.data)) {
                    externalErrors.value = [
                        {
                            key: 'selectedConsultationDate',
                            hint: 'Podany termin jest już zarezerwowany. Prosimy o wybranie innego terminu.',
                        },
                    ];
                    isSubmitting.value = false;
                } else {
                    processAddingToCart();
                }
            });
        } else {
            processAddingToCart();
        }
    };

    return { onSubmit, isSubmitting, addedToCart, addedToCartMessage, externalErrors };
};
